import React, { useState, useMemo, useEffect } from "react";
import { Link } from "gatsby";
import Pagination from "components/Pagination";
import { getFullDate } from "../../common/utils";
import { GatsbyImage } from "gatsby-plugin-image";
const TruncHtml = require("trunc-html");
const BlogGrid = ({ blogs }) => {

  const [currentPage, setCurrentPage] = useState(1);
  const PageSize = 6;

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return blogs?.slice(firstPageIndex, lastPageIndex).map(blogItem => {

      return {
        ...blogItem,
      };
    });
  }, [PageSize, blogs, currentPage]);

  return (
    <>
      <section className="blog-pg blog section-padding pt-0">
        <div className="container">
          <div className="posts">
            <div className="row">
              {currentTableData &&
                currentTableData.map((blogItem, k) => {

                  let title = blogItem?.title;
                  let desc = blogItem?.content.replace(
                    /<\/?[^>]+(>|$)/g,
                    ""
                  );

                  return (
                    <div className="col-lg-6" key={k}>
                      <div
                        className="item md-mb50 wow fadeInUp"
                        data-wow-delay=".3s"
                      >
                        <div className="img">
                          <GatsbyImage image={blogItem?.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData} loading="lazy"
                            alt={blogItem?.title}
                            className="blog-img"
                          />
                        </div>
                        <div className="cont">
                          <div>
                            <div className="info">
                              <Link
                                to={`/blog/${blogItem?.slug}`}
                                className="date"
                                onClick={() => { checkPaceClass() }}
                              >
                                <span>
                                  <i>{getFullDate(blogItem?.date)}</i>
                                </span>
                              </Link>
                              <span>/</span>

                              {blogItem?.tags?.nodes?.map((tag, index) => (
                                <Link
                                  key={index}
                                  to={`/tag/${tag.slug}`}
                                  className="tag"
                                  onClick={() => {
                                    checkPaceClass();
                                  }}
                                >
                                  <span>
                                    {tag.name}
                                    {blogItem?.tags?.nodes.length !== index + 1 ? ", " : ""}
                                  </span>
                                </Link>
                              ))}

                            </div>
                            <h5>
                              <Link to={`/blog/${blogItem?.slug}`} onClick={() => { checkPaceClass() }}>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: TruncHtml(title, 60).html,
                                  }}
                                />
                              </Link>
                            </h5>
                            <p>
                              {desc?.length > 250
                                ? desc?.substr(0, 250) + "..."
                                : desc}
                            </p>
                            <div className="btn-more">
                              <Link
                                to={`/blog/${blogItem?.slug}`}
                                onClick={() => { checkPaceClass() }}
                                className="simple-btn"
                              >
                                Read More
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              <div className="pagination">
                <Pagination
                  className="pagination-bar"
                  currentPage={currentPage}
                  totalCount={blogs ? blogs.length : 0}
                  pageSize={PageSize}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogGrid;
